import actions from "./actions";

const initState = {
    createGroupState: null,
    createGroupResult: null,
    readGroupListState: null,
    groups: [],
    readGroupState: null,
    group: {
        id: undefined,
        name: undefined,
        product_ids: [],
    },
    selectedProductIds: [],
    allProductIds: [],
    updateGroupState: null,
    deleteGroupState: null,
};

function reorderAllProductIds(allProductIds, selectedProductIds) {
    const selected = [];
    const unselected = [];

    allProductIds.forEach(id => {
        if (selectedProductIds.find(c => c === id))
            selected.push(id);
        else
            unselected.push(id);
    });

    return [...selected, ...unselected];
}

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.PRODUCT_GROUP_CREATE_REQUEST:
            return {
                ...state,
                createGroupState: 'request',
            };
        case actions.PRODUCT_GROUP_CREATE_SUCCESS:
            return {
                ...state,
                createGroupState: 'success',
                createGroupResult: action.data,
            };
        case actions.PRODUCT_GROUP_READ_LIST_REQUEST:
            return {
                ...state,
                readGroupListState: 'request',
            };
        case actions.PRODUCT_GROUP_READ_LIST_SUCCESS:
            return {
                ...state,
                readGroupListState: 'success',
                groups: action.groups,
            };
        case actions.PRODUCT_GROUP_READ_REQUEST:
            return {
                ...state,
                readGroupState: 'request',
            };
        case actions.PRODUCT_GROUP_READ_SUCCESS:
            return {
                ...state,
                readGroupState: 'success',
                group: action.group,
                selectedProductIds: action.group.product_ids,
                allProductIds: reorderAllProductIds(state.allProductIds, action.group.product_ids),
            };
        case actions.PRODUCT_GROUP_UPDATE_REQUEST:
            return {
                ...state,
                updateGroupState: 'request',
            };
        case actions.PRODUCT_GROUP_UPDATE_SUCCESS:
            return {
                ...state,
                updateGroupState: 'success',
            };
        case actions.PRODUCT_GROUP_DELETE_REQUEST:
            return {
                ...state,
                deleteGroupState: 'request',
            };
        case actions.PRODUCT_GROUP_DELETE_SUCCESS:
            return {
                ...state,
                deleteGroupState: 'success',
            };
        case actions.PRODUCT_GROUP_INIT:
            return {
                ...state,
                group: action.group,
                selectedProductIds: action.group.product_ids || [],
            };
        case actions.PRODUCT_GROUP_SET_PRODUCT_IDS:
            return {
                ...state,
                selectedProductIds: action.selectedProductIds,
            };
        case actions.PRODUCT_GROUP_SET_ALL_PRODUCT_IDS:
            return {
                ...state,
                allProductIds: reorderAllProductIds(action.allProductIds, state.selectedProductIds),
            };
        case actions.PRODUCT_GROUP_RESET:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
